export const buildDatePickerRange = (startDate: Date | null, endDate: Date | null) => ({
    start: () => startDate,
    end: () => endDate,
    max: () => {
        if (!startDate) return new Date('3000-01-01');
        const year = startDate.getFullYear();
        const month = startDate.getMonth();
        const day = startDate.getDate();
        const hours = startDate.getHours();
        const minutes = startDate.getMinutes();
        const seconds = startDate.getSeconds();
        const milliseconds = startDate.getMilliseconds();
        return new Date(year + 1, month, day, hours, minutes, seconds, milliseconds);
    },
});